import { Ds, focusBorderStyles } from "@accurx/design";
import styled from "styled-components";

export const SubTitleText = styled.span`
    display: inline-block;
    max-width: 100%;
    overflow-wrap: break-word;
    white-space: normal;
`;

export const FormFieldWithoutMB = styled(Ds.Form.Field)`
    margin-bottom: 0.25rem;
`;

// adding this temp style until SingleSelect component is migrated to new DS
export const SingleSelectOverrideStyle = styled.div`
    & button {
        box-shadow: none;

        &::before {
            border-color: var(--ds-color-stone);
        }

        &:focus {
            // This is to implement same focus styling as other input elements
            // as design library has not been updated yet
            ${focusBorderStyles}
            &::before {
                border: none;
            }

            &:after {
                outline: none;

                // The design library applies the box shadow here
                // But if we do, the component will be bigger
                // than other inputs
                box-shadow: none;
            }
        }

        &:hover,
        &:focus,
        &[aria-expanded="true"] {
            &::before {
                box-shadow: none;
            }
        }
    }
`;
